import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const NotificationHistorySchema = withDefaults({
  type: 'notification-history',
  objectExtensions: ['notification-history'],
  fields: [
    {
      kind: 'attribute',
      name: 'noteSubtype',
    },
    {
      kind: 'attribute',
      name: 'noteType',
    },
    {
      kind: 'attribute',
      name: 'createdAt',
    },
    {
      kind: 'attribute',
      name: 'toEmail',
    },
    {
      kind: 'attribute',
      name: 'fromEmail',
    },
    {
      kind: 'attribute',
      name: 'templateId',
    },
    {
      kind: 'attribute',
      name: 'templateSubstitutions',
    },
    {
      kind: 'attribute',
      name: 'noteSuccessful',
    },
    {
      kind: 'attribute',
      name: 'trackingToken',
    },
    {
      kind: 'attribute',
      name: 'firstOpenedAt',
    },
    {
      kind: 'attribute',
      name: 'openCount',
    },
    {
      kind: 'attribute',
      name: 'trackingPixelHtml',
    },
    // Index carries hasSentSnapshot/renderingMode; only admin show requests receive sentSubject/sentBodyHtml.
    {
      kind: 'attribute',
      name: 'hasSentSnapshot',
    },
    {
      kind: 'attribute',
      name: 'renderingMode',
    },
    {
      kind: 'attribute',
      name: 'sentSubject',
    },
    {
      kind: 'attribute',
      name: 'sentBodyHtml',
    },
    {
      kind: 'belongsTo',
      name: 'user',
      type: 'user',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'belongsTo',
      name: 'employee',
      type: 'employee',
      options: {
        async: false,
        inverse: null,
      },
    },
  ],
});

export default NotificationHistorySchema;
